var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryLike = function SvgHistoryLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D4F",
    d: "M14.422 4.431a4.1 4.1 0 0 0-.89-1.293 4.146 4.146 0 0 0-2.912-1.184A4.17 4.17 0 0 0 8 2.876a4.173 4.173 0 0 0-2.62-.923 4.15 4.15 0 0 0-2.913 1.184A4.04 4.04 0 0 0 1.25 6.023c0 .52.106 1.063.317 1.615.177.46.43.939.753 1.421.513.764 1.218 1.561 2.093 2.37a23.4 23.4 0 0 0 2.946 2.3l.37.238a.5.5 0 0 0 .54 0l.37-.237c.061-.04 1.495-.963 2.947-2.302.875-.808 1.58-1.605 2.092-2.369.324-.482.578-.96.753-1.421a4.5 4.5 0 0 0 .317-1.615 4 4 0 0 0-.326-1.592"
  })));
};
export default SvgHistoryLike;